import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;
function api(path) {
  const token = localStorage.getItem('token');
  return fetch(`${API_BASE_URL}${path}`, { headers: { Authorization: `Bearer ${token}` } }).then(async r => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.message || d.error || `Request failed (HTTP ${r.status})`);
    return d;
  });
}

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #0f172a' }}>
      <span style={{ color: '#64748b', fontSize: 13 }}>{label}</span>
      <span style={{ fontSize: 13, fontWeight: 600 }}>{value}</span>
    </div>
  );
}

export default function MaterialScan() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api(`/materials/scan/${uuid}`).then(d => { setItem(d); setLoading(false); }).catch(e => { setError(e.message); setLoading(false); });
  }, [uuid]);

  if (loading) return <div style={{ padding: 32, fontFamily: 'sans-serif', color: '#e2e8f0', backgroundColor: '#0f172a', minHeight: '100vh' }}>Loading…</div>;
  if (error) return <div style={{ padding: 32, fontFamily: 'sans-serif', color: '#fca5a5', backgroundColor: '#0f172a', minHeight: '100vh' }}>Could not load this label: {error}<div style={{ color: '#64748b', fontSize: 13, marginTop: 8 }}>Make sure you are logged in to FieldCore on this device.</div></div>;
  if (!item) return <div style={{ padding: 32, fontFamily: 'sans-serif', color: '#fca5a5', backgroundColor: '#0f172a', minHeight: '100vh' }}>Label not found.</div>;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0f172a', color: '#e2e8f0', fontFamily: 'sans-serif', padding: 20 }}>
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 6, letterSpacing: 1 }}>📦 MATERIAL ITEM</div>
        <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>{item.description}</div>
        <div style={{ color: '#94a3b8', marginBottom: 16 }}>
          {item.received_qty != null ? `${item.received_qty}` : item.expected_qty} {item.unit || ''}
          {item.part_number ? ` · ${item.part_number}` : ''}
        </div>

        <div style={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 16, marginBottom: 14 }}>
          <Row label="Job" value={item.work_item_title} />
          {item.wo_number && <Row label="WO #" value={item.wo_number} />}
          {item.sn_ticket && <Row label="SN" value={item.sn_ticket} />}
          {item.location_name && <Row label="Location" value={item.location_name} />}
          {item.po_number && <Row label="PO #" value={item.po_number} />}
          <Row label="Shipment" value={item.shipment_status} />
        </div>

        <button onClick={() => navigate(`/work/${item.work_item_id}`)} style={{ width: '100%', padding: 14, backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: 8, fontWeight: 800, fontSize: 15, cursor: 'pointer' }}>
          Open Job →
        </button>
      </div>
    </div>
  );
}
